import React from "react";
import BackgroundImage from "./BackgroundImage";
import "./Section3.scss";

function Section3(props) {
  const {
    color,
    size,
    title,
    subtitle, // Add a subtitle prop
    image,
    backgroundImage,
    backgroundImageOpacity,
    backgroundImageRepeat,
    className,
    children,
    // Passed to section element
    ...otherProps
  } = props;

  return (
    <section
      className={
        "SectionComponent3 hero section is-block is-relative margin-responsive" +
        (color ? ` is-${color}` : "") +
        (size ? ` is-${size}` : "") +
        (className ? ` ${className}` : "")
      }
      {...otherProps}
    >
      {backgroundImage && (
        <BackgroundImage
          image={backgroundImage}
          opacity={backgroundImageOpacity}
          repeat={backgroundImageRepeat}
        />
      )}
      
      {title && (
        <h1 className="title">{title}</h1>
      )}
      <br>
      </br>
      {subtitle && ( // Render the subtitle if it's provided
        <p className="subtitle">{subtitle}</p>
      )}
      <img src={image} alt="Illustration" />
      {children}
    </section>
  );
}

export default Section3;
